module.exports = __webpack_public_path__ + "static/media/profilt_loss_icon.061ae173.svg";